import { intelligentStatus } from '@/utils/contants/intelligentQA';
import s from './style.module.scss';
import { GrtAiMarkdown } from '@/components/Markdown/GrtAiMarkdown';
const Result = (props) => {
    const { intelligent_qa_status = '' } = props;
    const isSpecificContent = intelligent_qa_status?.status === intelligentStatus?.specificcontent;
    return (
        <>
            <div
                data-text={isSpecificContent ? '' : intelligent_qa_status?.label || ''}
                className={`${s['tip-text']}  ${isSpecificContent ? 'loading-text' : ''}`}
            >
                <GrtAiMarkdown content={intelligent_qa_status?.label}></GrtAiMarkdown>
            </div>
        </>
    );
};
export default Result;
